import { BlastEvent, SimulationConfig } from '@/types';
import { drawBlastShape } from '@/logic/break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const SmokeRingAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  ctx.shadowBlur = 40 * (1-progress); ctx.shadowColor = ctx.strokeStyle as string;
  drawBlastShape(ctx, e, e.maxRadius + progress * 100);
  ctx.lineWidth = 25 * (1-progress); ctx.stroke(); ctx.shadowBlur = 0;
};

registerBlastAnimation('SMOKE_RING', SmokeRingAnimation);
